// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__z8RXi","header":"PatientBlock_header__2aToQ","label":"PatientBlock_label__3JtG2","option":"PatientBlock_option__1P6Nr"};